<div class="maintenance-screen">
  <div class="maintenance-card">
    <div class="icon-badge">
      <mat-icon>construction</mat-icon>
    </div>

    <small>Scheduled Maintenance</small>
    <h1>We'll be right back</h1>
    <p>
      Nakel Services is currently undergoing scheduled maintenance while we
      make improvements. We won't be long — please check back shortly.
    </p>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="reload()">
        <mat-icon>refresh</mat-icon>
        Try again
      </button>
      @if (whatsappNumber) {
        <a mat-stroked-button [href]="'https://wa.me/' + whatsappNumber" target="_blank" rel="noopener">
          <mat-icon>chat</mat-icon>
          Contact us
        </a>
      }
    </div>
  </div>
</div>
